function fn_comp_featuring() {
    var $fn = $(".comp_featuring");

    $fn.find("[data-switch]").nl_switch();

    $fn.find(".elm_nav").hover(
        function() {
            $(this).find(".elm_item").addClass("mod--hover");
        }, function() {
            $(this).find(".elm_item").removeClass("mod--hover");
        }
    );
}